var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chapter-view pt-12 pb-20" }, [
    _c(
      "div",
      { staticClass: "col-12 typography--body-1 typography--font-weight-500" },
      [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t("series_cards.chapters.index", { i: _vm.chapter.position })
            ) +
            ": " +
            _vm._s(_vm.chapter.name) +
            "\n\n    "
        ),
        _c(
          "small",
          {
            staticClass: "link-btns clickable ml-1",
            on: {
              click: function($event) {
                return _vm.$emit("open-chapter-edit-modal", _vm.chapter)
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("common.edit")))]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "link-btns typography--color-primary ml-2",
            attrs: { to: _vm.createDocxQuizzesLink }
          },
          [
            _c("small", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("publishers.create_docx_quizzes.title")) +
                  "\n      "
              )
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "col-12 typography--body-2 typography--color-secondary mt-6"
      },
      [
        _c("span", { staticClass: "mr-6" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("series_cards.chapters.meta.card_count", {
                  cnt: _vm.cardCount
                })
              ) +
              "\n    "
          )
        ]),
        _vm._v("\n    |\n    "),
        _c("span", { staticClass: "ml-6 mr-6" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("series_cards.chapters.meta.domain")) +
              ":\n      " +
              _vm._s(_vm.getDomainLabel(_vm.chapter.domain) || "-") +
              "\n    "
          )
        ]),
        _vm._v("\n    |\n    "),
        _c("span", { staticClass: "ml-6" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("series_cards.chapters.meta.core_concept")) +
              ":\n      " +
              _vm._s(_vm.getCoreConceptLabel(_vm.chapter.core_concept) || "-") +
              "\n    "
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "draggable",
          {
            staticClass: "chapter-view__card-list row",
            on: {
              start: function($event) {
                _vm.drag = true
              },
              end: function($event) {
                _vm.drag = false
              }
            },
            model: {
              value: _vm.chapterCardList,
              callback: function($$v) {
                _vm.chapterCardList = $$v
              },
              expression: "chapterCardList"
            }
          },
          _vm._l(_vm.chapterCardList, function(card) {
            return _c(
              "div",
              { key: card.id, staticClass: "col-sm-6 col-md-4 col-lg-3" },
              [
                _c(
                  "div",
                  { staticClass: "card-row" },
                  [
                    _c("PublisherCardView", {
                      attrs: { card: card, "is-series-card": true },
                      on: {
                        "open-remove-from-series-modal": function($event) {
                          return _vm.$emit(
                            "open-remove-from-series-modal",
                            card.id
                          )
                        },
                        "open-remove-card-modal": function($event) {
                          return _vm.$emit("open-remove-card-modal", card.id)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          }),
          0
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52e2bc1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52e2bc1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/components/ChapterView.vue
// module id = Tarp
// module chunks = 1